var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_export_graph_class = function () {
    OCS.Classes.ExportGraph = new Class({
        Implements: [Options, Events, new Class(OCS.Interfaces.ExportGraph)],
        options: {
            filename: 'chart',
            type: 'image/png',
            scale: 2
        }
    });
};
OCS.Functions.define_export_graph_class();